module.exports = __webpack_public_path__ + "static/media/mapScope.18bc0659.png";